
import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'
import { getWarehouseSettingsRequest, getWarehouseSettingByIdRequest, getWarehouseSettingById } from 'selectors'

export const CREATING_WAREHOUSE = 'CREATING_WAREHOUSE'
export const CREATE_WAREHOUSE_ERROR = 'CREATE_WAREHOUSE_ERROR'
export const CREATED_WAREHOUSE = 'CREATED_WAREHOUSE'

const creatingWarehouse = createAction(CREATING_WAREHOUSE)
const createdWarehouse = createAction(CREATED_WAREHOUSE)
const createWarehouseError = createAction(CREATE_WAREHOUSE_ERROR)

export const createWarehouse = ({ workspaceSlug, databaseId, settings }) => dispatch => {
  dispatch(creatingWarehouse({ workspaceSlug }))

  fetch(`/api/workspaces/${workspaceSlug}/warehouses`, {
    method: 'POST',
    body: JSON.stringify({ settings, databaseId })
  })
  .then(res => {
    if (!res.ok) {
      const error = getCreateError(null, res)
      dispatch(createWarehouseError({ workspaceSlug, error }))
    } else {
      return res.json()
    }
  })
  .then(data => {
    dispatch(createdWarehouse({ workspaceSlug, data }))
  })
  .catch(error => {
    dispatch(createWarehouseError({ workspaceSlug, error }))
  })
}

function getCreateError (err, res) {
  if (err) {
    return err
  }

  return {
    code: res.status,
    error: res.text || ''
  }
}

export const REQUESTING_WAREHOUSES = 'REQUESTING_WAREHOUSES'
export const REQUEST_WAREHOUSES_ERROR = 'REQUEST_WAREHOUSES_ERROR'
export const RECEIVE_WAREHOUSES = 'RECEIVE_WAREHOUSES'

export const fetchWarehouses = workspaceSlug => ({
  types: {
    request: REQUESTING_WAREHOUSES,
    failure: REQUEST_WAREHOUSES_ERROR,
    receive: RECEIVE_WAREHOUSES
  },
  payload: { workspaceSlug },
  shouldCallAPI: state => {
    const { isRequesting, hasRequested, didRequestFail } = getWarehouseSettingsRequest(state, workspaceSlug)
    if (isRequesting) {
      return false
    }

    if (!hasRequested) {
      return true
    }

    return didRequestFail
  },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/warehouses`).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to fetch warehouses')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const REQUEST_WAREHOUSE_BY_ID = 'REQUEST_WAREHOUSE_BY_ID'
export const RECEIVE_WAREHOUSE_BY_ID = 'RECEIVE_WAREHOUSE_BY_ID'
export const REQUEST_WAREHOUSE_BY_ID_ERROR = 'REQUEST_WAREHOUSE_BY_ID_ERROR'
export const fetchWarehosueById = (workspaceSlug, warehouseId) => ({
  types: {
    request: REQUEST_WAREHOUSE_BY_ID,
    receive: RECEIVE_WAREHOUSE_BY_ID,
    failure: REQUEST_WAREHOUSE_BY_ID_ERROR
  },
  payload: { workspaceSlug, warehouseId },
  shouldCallAPI: state => {
    const { isRequesting } = getWarehouseSettingByIdRequest(state, workspaceSlug, warehouseId)
    if (isRequesting) return false
    const warehouse = getWarehouseSettingById(state, workspaceSlug, warehouseId)
    return !warehouse
  },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/warehouses/${warehouseId}`).then(res => {
    if (!res.ok) {
      const error = new Error(`Unable to fetch warehouse "${workspaceSlug}/${warehouseId}"`)
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const UPDATING_WAREHOUSE_SETTINGS = 'UPDATING_WAREHOUSE_SETTINGS'
export const UPDATED_WAREHOUSE_SETTINGS = 'UPDATED_WAREHOUSE_SETTINGS'
export const UPDATE_WAREHOUSE_SETTINGS_ERROR = 'UPDATE_WAREHOUSE_SETTINGS_ERROR'
export const updateWarehouseSettingsById = (workspaceSlug, warehouseId, settings) => ({
  types: {
    request: UPDATING_WAREHOUSE_SETTINGS,
    receive: UPDATED_WAREHOUSE_SETTINGS,
    failure: UPDATE_WAREHOUSE_SETTINGS_ERROR
  },
  payload: { workspaceSlug, warehouseId: warehouseId },
  callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/warehouses/${warehouseId}/settings`, {
    method: 'PATCH',
    body: JSON.stringify(settings)
  }).then(res => {
    if (!res.ok) {
      const error = new Error('Unable to update warehouse')
      error.code = res.status
      throw error
    }
    return res.json()
  })
})

export const SET_BIGQUERY_WAREHOUSE_PROJECT_ID = 'SET_BIGQUERY_WAREHOUSE_PROJECT_ID'
export const setBigqueryWarehouseProjectId = createAction(SET_BIGQUERY_WAREHOUSE_PROJECT_ID)



// WEBPACK FOOTER //
// ./actions/warehouses.js